const columnsConfig = [
  {
    key: 'partner',
    label: 'Partner',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '220px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'none',
      minWidth: '220px',
      textAlign: 'left',
    },
  },
  {
    key: 'cards',
    label: 'Cards',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '180px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '180px',
      textAlign: 'left',
    },
  },
  {
    key: 'description',
    label: 'Description',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '200px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'none',
      minWidth: '200px',
      textAlign: 'left',
    },
  },
  {
    key: 'status',
    label: 'Status',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '120px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '120px',
      textAlign: 'left',
    },
  },
  {
    key: 'time',
    label: 'Time',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '180px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'none',
      minWidth: '180px',
      textAlign: 'left',
    },
  },
  {
    key: 'nominal',
    label: 'Nominal',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '150px',
      textAlign: 'left',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'none',
      minWidth: '150px',
      textAlign: 'left',
    },
  },
  {
    key: 'action',
    label: 'Action',
    thClass: 'text-center',
    tdClass: 'text-center',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '150px',
      textAlign: 'center',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'none',
      minWidth: '150px',
      textAlign: 'center',
    },
  },
]

const statusOptions = [
  { value: 'all', label: 'All Status' },
  { value: 'idle', label: 'Idle' },
  { value: 'success', label: 'Success' },
  { value: 'failed', label: 'Failed' },
]

const userLevelOptions = [
  { value: 'all', label: 'All User' },
  { value: 'priority', label: 'Priority User' },
]

const statusColorMap = {
  idle: 'text-[#F2994A]',
  success: 'text-[#27AE60]',
  failed: 'text-[#E12A2A]',
}

const statusIconMap = {
  idle: 'k-status',
  success: 'k-tick-circle',
  failed: 'k-close-circle',
}

const OPTIONS_PAGE = [25, 50, 100, 200]

export {
  columnsConfig,
  statusOptions,
  userLevelOptions,
  statusColorMap,
  statusIconMap,
  OPTIONS_PAGE,
}
export default columnsConfig
